export enum ReportingMutationTypes {
  SET_REPORTING_TABLE = 'SET_REPORTING_TABLE',
  SET_REPORTING_ACTIVITY = 'SET_REPORTING_ACTIVITY',
  CLEAR_REPORTING_TABLE = 'CLEAR_REPORTING_TABLE',
}
